var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flex _jc-sb _ai-c _gap-1" },
    [
      _c(
        "div",
        [
          _c(
            "base-heading",
            { staticClass: "gfu-hd--h3", attrs: { tag: "h3" } },
            [_vm._v("\n            " + _vm._s(_vm.headingText) + "\n        ")]
          ),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n            " + _vm._s(_vm.descriptionText) + "\n        "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isOpenForOrders
        ? _c(
            "base-button",
            {
              staticClass: "_shrink-0",
              attrs: {
                tag: "a",
                href: _vm.backProjectUrl,
                theme: "accent",
                "data-qa": "comment-section:BackNow",
              },
              on: { click: _vm.sendAnalytics },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.Resources.Comments.BackNowButton) +
                  "\n    "
              ),
            ]
          )
        : _c("follow-project-button", {
            attrs: {
              "project-id": _vm.projectId,
              section: "comment-restricion",
              "project-name": _vm.projectName,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ onSubscribe }) {
                  return [
                    _c(
                      "base-button",
                      {
                        staticClass: "_shrink-0",
                        attrs: {
                          theme: "accent",
                          "data-qa": "comment-section:Follow",
                        },
                        on: { click: onSubscribe },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.Resources.ProjectHome.FollowProjectButton
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }